import styled from '@emotion/styled';
import { colors, fontWeights, radii, space } from '@opendoor/bricks/theme/eero';

const Banner = styled.div`
  width: 100%;
  height: ${space[10]};
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${colors.neutrals100};
  color: ${colors.neutrals0};
  border-top-right-radius: ${radii.roundedSquare};
  border-top-left-radius: ${radii.roundedSquare};
  position: absolute;
  top: 0;
  left: 0;
  font-size: 16px;
  font-weight: ${fontWeights.bold};
`;

const TestModeBanner = () => <Banner>You are currently viewing test data</Banner>;

export default TestModeBanner;
